import React, { Component } from 'react';
import Icon from '../../../../icons/Icon';
import { currency, CurrencyModel } from '../../../../util/Currency';
import ComponentName from '../../../../constant/ComponentName';

class CaseChartIndicatorComponent extends Component<Props> {
  public render() {
    const { score, label, icon, currency } = this.props;

    return (
      <div
        style={{ zIndex: 0, boxShadow: '2px 2px 15px 0px #0000000D' }}
        className={'inline-flex  min-h-[82px] h-[82px] w-full bg-white items-center justify-start gap-x-3 px-4 py-5 rounded-[8px]'}
        data-testid={`${ComponentName.CASE}_detail_chart_indicator_${label}_container`}
      >
        <section className={'w-10 h-10 flex items-center justify-center rounded-full bg-secondary'}>
          <Icon size={16} className={'w-[40px] h-[40px] text-f-purple'} icon={icon ? icon : 'transaction'} />
        </section>
        <section>
          <p data-testid={`${ComponentName.CASE}_detail_chart_indicator_${label}_label_text`} className={'text-[#AAAAAA] lg:text-sm '}>
            {label}
          </p>
          <p className={'text-[#4F4F4F 2xl'} data-testid={`${ComponentName.CASE}_detail_chart_indicator_${label}_score_text`}>
            {currency && this.getCurrencyObject().symbol_native} {score}
          </p>
        </section>
      </div>
    );
  }

  private getCurrencyObject(): CurrencyModel {
    return currency[this.props.currency || 'USD'];
  }

  private getCurrencySymbol(): string {
    return this.getCurrencyObject().symbol_native;
  }
}

interface Props {
  score: string;
  label: string;
  icon?: string;
  currency?: string;
}

export default CaseChartIndicatorComponent;
